import DashboardLayout from "../../layouts/DashboardLayout";
import TrialCampaignCard from "../../components/admin/TrialCampaignCard";

export default function AdminTrialCampaign() {
  return (
    <DashboardLayout>
      <div className="container mx-auto p-4 md:p-8">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Free-Trial Campaign</h1>
          <p className="text-sm text-gray-500 mt-1">
            Configure terms, limits, and status for public doctor self-onboarding trials.
          </p>
        </div>

        <TrialCampaignCard />
      </div>
    </DashboardLayout>
  );
}
